import { useState, useEffect } from 'react';

// Time left until `target`, ticking every second. Shared by the challenge
// page's countdown and the landing page's challenge banner.
export const useCountdown = (target) => {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, []);
    const ms = Math.max(0, new Date(target).getTime() - now);
    return {
        done: ms === 0,
        days: Math.floor(ms / 86400000),
        hours: Math.floor(ms / 3600000) % 24,
        minutes: Math.floor(ms / 60000) % 60,
        seconds: Math.floor(ms / 1000) % 60,
    };
};
